import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetChangeRequestsModelContextDocument,
  type GetChangeRequestsModelContextQuery,
  type GetChangeRequestsModelContextQueryVariables,
} from "~/features/changeRequests/gqls";
import { useTenant } from "~/features/tenant/context";

/** Lookup data for the search sidebar: statuses, review types, data-import projects, categories. */
export function useChangeRequestModelContext() {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  const { data } = useSuspenseQuery<GetChangeRequestsModelContextQuery, GetChangeRequestsModelContextQueryVariables>(
    GetChangeRequestsModelContextDocument,
    { variables: { tenantId } },
  );
  return {
    statuses: data.changeRequestStatuses,
    reviewTypes: data.changeRequestReviewTypes,
    dataImportProjects: data.dataImportProjects,
    categories: data.categories,
  };
}
